import {
    CUSTOM_SHORTCUT_CHANGE_OPERATOR_STATUS_TYPE_ID,
    CUSTOM_SHORTCUT_OPEN_LINK_FROM_CLIENT_INFO_TYPE_ID,
    CUSTOM_SHORTCUT_SEND_FORM_TYPE_ID,
    CUSTOM_SHORTCUT_SEND_INFO_TYPE_ID,
    CUSTOM_SHORTCUT_START_BOT_TYPE_ID,
    CUSTOM_SHORTCUT_USE_MESSAGE_TEMPLATE_TYPE_ID,
    CustomShortcutChangeOperatorStatusPayloadInterface,
    CustomShortcutTypeId
} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import {computed} from "vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {__} from "~/ts/library/Translate";
import {TAB_TYPE_FORM, TAB_TYPE_HTML} from "~/chat/ts/data/ITab";
import {getSendTabShowTypes, ShowTypeId} from "~/operatorApplication/ts/service/dialog/OperatorApplicationSendTab";
import StringHelper from "~/ts/library/StringHelper";

interface CustomShortcutTypeInterface {

    id: CustomShortcutTypeId,
    descr: string,
    payloadGroups: {
        id: string,
        descr: string,
        options: CustomShortcutPayloadOption[]
    }[]
}

export interface SendTabShortcutPayloadInterface {
    tabId: string,
    showType: ShowTypeId
}

function getTabTemplateType(typeId: CustomShortcutTypeId, typeDescr: string, tabTypeId: string): CustomShortcutTypeInterface {
    let showTypes = getSendTabShowTypes();
    return {
        id: typeId,
        descr: typeDescr,
        payloadGroups: OperatorAccountStore.data.value.sites
            .filter(site => site.tabs.find(tab => tab.typeId == tabTypeId))
            .map(site => {
                let options: CustomShortcutPayloadOption[] = [];
                for (let tab of site.tabs.filter(tab => tab.typeId == tabTypeId)) {
                    for (let showType of showTypes) {
                        let payload: SendTabShortcutPayloadInterface = {
                            tabId: tab.id,
                            showType: showType.id
                        }
                        options.push({
                            id: JSON.stringify(payload),
                            descr: `${tab.descr} / ${showType.descr}`
                        })
                    }
                }
                return {
                    id: site.id,
                    descr: site.title,
                    options
                };
            })
    };
}

export function getCustomShortcutTypes(): CustomShortcutTypeInterface[] {
    let sitesWithTemplates: { id: string, title: string }[] = computed(() => {
        return OperatorAccountStore.data.value.sites.filter(site => !!OperatorAccountStore.getMessageTemplatesBySite(site.id).templates.find(template => !template.systemTypeId));
    }).value.map(site => ({
        id: site.id,
        title: site.title
    }));

    let sitesWithBots = computed(() => {
        return OperatorAccountStore.data.value.sites.filter(site => site.bots?.length > 0);
    }).value;

    let commonTemplates = OperatorAccountStore.getMessageTemplatesBySite(null);
    if (commonTemplates.templates.length) {
        sitesWithTemplates.splice(0, 0, {
            id: null,
            title: __("Доступно на всех сайтах")
        })
    }

    return [
        {
            id: CUSTOM_SHORTCUT_USE_MESSAGE_TEMPLATE_TYPE_ID,
            descr: __("Подставить шаблон сообщения"),
            payloadGroups: sitesWithTemplates.map(site => {
                return {
                    id: site.id,
                    descr: site.title,
                    options: OperatorAccountStore.getMessageTemplatesBySite(site.id)
                        .templates
                        .filter(template => !template.systemTypeId)
                        .map(template => ({
                            id: template.id,
                            descr: template.descr
                        }))
                }
            })
        },
        {
            id: CUSTOM_SHORTCUT_START_BOT_TYPE_ID,
            descr: __("Запустить бота"),
            payloadGroups: sitesWithBots.map(site => {
                return {
                    id: site.id,
                    descr: site.title,
                    options: site.bots.map(bot => ({
                        id: bot.id,
                        descr: bot.descr
                    }))
                }
            })
        },
        getTabTemplateType(CUSTOM_SHORTCUT_SEND_FORM_TYPE_ID, __("Отправить форму"), TAB_TYPE_FORM),
        getTabTemplateType(CUSTOM_SHORTCUT_SEND_INFO_TYPE_ID, __("Отправить информацию"), TAB_TYPE_HTML),
        {
            id: CUSTOM_SHORTCUT_OPEN_LINK_FROM_CLIENT_INFO_TYPE_ID,
            descr: __("Открыть ссылку из информации о клиенте"),
            payloadGroups: OperatorAccountStore.data.value.sites.map(site => {
                return {
                    id: site.id,
                    descr: site.title,
                    options: site.userFields.map(field => ({
                        id: field.name,
                        descr: field.descr
                    }))
                }
            })
        },
        {
            id: CUSTOM_SHORTCUT_CHANGE_OPERATOR_STATUS_TYPE_ID,
            descr: __("Изменить статус оператора"),
            payloadGroups: [{
                id: 'statusList',
                descr: '',
                options: OperatorAccountStore.statusList.value.map(status => ({
                    id: JSON.stringify({
                        statusId: status.statusId,
                        customStatusId: status.customStatusId
                    } as CustomShortcutChangeOperatorStatusPayloadInterface),
                    descr: StringHelper.capitalize(status.descr)
                }))
            }]
        },
    ]
}

interface CustomShortcutPayloadOption {
    id: string
    descr: string;
}
